import { type HTMLAttributes, type RefObject } from 'react';
import classnames from '@common/utils/ui/classnames';
import '@common/styles/components/container.pcss';

interface Props extends HTMLAttributes<HTMLDivElement> {
  mobileFullWidth?: boolean;
  fullHeight?: boolean;
  noShadow?: boolean;
  containerRef?: RefObject<HTMLDivElement | null>;
}

function Container(
  { className = '', mobileFullWidth, fullHeight, noShadow, containerRef, ...rest }: Readonly<Props>,
) {
  return (
    <div
      ref={containerRef}
      className={classnames({
        'basic-container': true,
        'basic-container--mobileFullWidth': mobileFullWidth,
        'basic-container--full-height': fullHeight,
        'basic-container--no-shadow': noShadow,
        [className]: !!className,
      })}
      {...rest}
    />
  );
}

export default Container;
